import axios from 'axios';
import { API_URL } from '../config';

export const getPermissions = async (token: string) => {
  const response = await axios.get(`${API_URL}/hr/permissions/`, {
    headers: {
      'Authorization': token,
    }
  });
  return response.data;
};

export const getCompanyPermissions = async (token: string) => {
    const response = await axios.get(`${API_URL}/hr/companies/permissions/`, {
      headers: {
        'Authorization': token,
      }
    });
    return response.data;
};

export const addCompanyPermission = async (token: string, permissionId: number) => {
  const response = await axios.put(`${API_URL}/hr/companies/permissions/add/`, { permission_ids: [permissionId] },
    {
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export const removeCompanyPermission = async (token: string, permissionId: number) => {
  const response = await axios.put(`${API_URL}/hr/companies/permissions/remove/`, { permission_ids: [permissionId] },
    {
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};


export const getEmployeePermissions = async (token: string, employeeId: number) => {
  const response = await axios.get(`${API_URL}/hr/employees/${employeeId}/permissions/`, {
    headers: {
      'Authorization': token,
    },
    params: {
      id: employeeId,
    }
  });
  return response.data;
}

export const getPermissionsDetailed = async (token: string, employeeId: number) => {
  const response = await axios.get(`${API_URL}/hr/employees/${employeeId}/permissions-detailed/`, {
    headers: {
      'Authorization': token,
    },
    params: {
      id: employeeId,
    }
  });
  return response.data;
}

export const addEmployeePermission = async (token: string, employeeId: number, permissionId: number) => {
  const response = await axios.put(`${API_URL}/hr/employees/${employeeId}/permissions/add/`, { permission_ids: [permissionId] },
    {
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
  };

export const removeEmployeePermission = async (token: string, employeeId: number, permissionId: number) => {
  const response = await axios.put(`${API_URL}/hr/employees/${employeeId}/permissions/remove/`, { permission_ids: [permissionId] },
    {
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};


export const getOusPermissions = async (token: string, ouId: number) => {
  const response = await axios.get(`${API_URL}/hr/ous/${ouId}/permissions/`, {
    headers: {
      'Authorization': token,
    },
    params: {
      id: ouId,
    }
  });
  return response.data;
}

export const addOusPermission = async (token: string, ouId: number, permissionId: number) => {
  const response = await axios.put(`${API_URL}/hr/ous/${ouId}/permissions/add/`, { permission_ids: [permissionId] },
    {
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export const removeOusPermission = async (token: string, ouId: number, permissionId: number) => {
  const response = await axios.put(`${API_URL}/hr/ous/${ouId}/permissions/remove/`, { permission_ids: [permissionId] },
    {
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

